module.exports = __webpack_public_path__ + "static/img/PR@3x.df61c54d.jpg";